import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import appStoresQuery from '@/plugins/graphql/queries/v2/store_management/mall-stores.gql';
import { textTruncate } from '@/helpers/text_truncate';
import StoreInvitationForm from '@/components/v2/StoreInvitationForm.vue';
let Stores = class Stores extends Mixins(ViewportSizeMixin, RouteParamsAppMixin) {
    get queryOnFlight() {
        return this.$apollo.queries.appStores.loading;
    }
    get headers() {
        return [
            {
                text: '',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STORE NAME',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'storeDescription',
                align: 'left',
                truncated: true,
                isCurrency: true,
            },
            {
                text: 'STORE OWNER EMAIL',
                value: 'ownerFullName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STORE STATUS',
                value: 'storeStatus',
                align: 'left',
                sortable: false,
                replaceValue: true,
            },
        ];
    }
    truncatedDescription(description) {
        if (this.smAndUp) {
            return textTruncate(description || 'N/A', 100);
        }
        return textTruncate(description || 'N/A', 25);
    }
    humanizedStatus(status) {
        if (status === 'active_store') {
            return 'ACTIVE';
        }
        return 'CLOSED';
    }
    colorClassByStatus(status) {
        if (status === 'active_store') {
            return 'green--text';
        }
        return 'red--text';
    }
};
Stores = __decorate([
    Component({
        components: {
            ActionButton,
            PageTitle,
            StoreInvitationForm,
        },
        apollo: {
            appStores: {
                query: appStoresQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
            },
        },
    })
], Stores);
export default Stores;
